/**
 * Toggles visibility between the Template and Upload sections
 */
function setupByteToggle() {
    const toggle = document.getElementById('collabToggle');
    const templateSection = document.getElementById('use-template-below');
    const uploadSection = document.getElementById('upload-document-below');

    // Safety check to ensure elements exist on the page
    if (!toggle || !templateSection || !uploadSection) return;

    const handleToggle = () => {
        if (toggle.checked) {
            templateSection.style.display = 'none';
            uploadSection.style.display = 'block';
        } else {
            templateSection.style.display = 'block';
            uploadSection.style.display = 'none';
        }
    };

    // Initialize state
    handleToggle();

    // Listen for changes
    toggle.addEventListener('change', handleToggle);
}

// Run the function after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', setupByteToggle);



